import { __awaiter, __generator } from "tslib";
import { fetchPost } from '../../common/http/fetch-post';
import { getCompatibilityGuideApiConfig } from "./config/actions";
import { buildAvailableStateQuery } from './utilities/build-available-state-query';
export var fetchCompareDetails = function (thirdPartyProducts, products, availableState) {
    if (thirdPartyProducts === void 0) { thirdPartyProducts = []; }
    if (products === void 0) { products = []; }
    if (availableState === void 0) { availableState = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        var config, state, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = getCompatibilityGuideApiConfig();
                    state = buildAvailableStateQuery(availableState);
                    url = config.baseUrl + "/api/compare/" + thirdPartyProducts.join(',') + "?marketLocale=" + config.marketLocale + state;
                    return [4 /*yield*/, fetchPost(url, products)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
